import axios from 'axios';
import Swal from 'sweetalert2';

document.querySelector('#serviceRequest') && new Vue({
    el: '#serviceRequest',
    data: function () {
        return {
            date_of_request: null,
            item: null,
            quantity: 1,
            selected_items: [

            ],
            vehicle_id: null,
            gas_slip: null,
        };
    },
    computed: {
        selected_vehicle() {
            if (this.vehicle_id == null) {
                return null;
            }

            return vehicles.find((a) => a.id == this.vehicle_id);
        }
    },
    methods: {
        add() {
            if (this.item == null) {
                return;
            }

            var item = serviceItems.find((a) => a.id == this.item);
            this.selected_items.push({
                item: item,
                quantity: this.quantity,
            });
        },
        removeItem(idx) {
            this.selected_items = this.selected_items.filter((a, b) => b != idx);
        },
        showConfirmationModal() {
            try {
                if (this.date_of_request == null) {
                    throw 'Please enter date of request';
                }

                if (this.vehicle_id == null) {
                    throw 'No vehicle selected';
                }

                if (this.selected_items.length == 0) {
                    throw 'No items added';
                }

                $('#confirmationModal').modal('show');

            } catch (e) {
                new Swal('Error', e, 'error');
            }


        },
        print() { },
        async submit() {
            try {
                var res = await axios.post('/office/service-request', {
                    date_of_request: this.date_of_request,
                    vehicle_id: this.vehicle_id,
                    selected_items: this.selected_items,
                });

                this.date_of_request = null;
                this.vehicle_id = null;
                this.selected_items = [];

                $('#confirmationModal').modal('hide');

                new Swal('Success!', 'Lubricants/Service request submitted successfully', 'success');

            } catch (e) {
                new Swal('Error', e, 'error');
            }
        }
    },
    mounted() {
        $('#vehicle_select').select2();
        $('#vehicle_select').on('change', (event) => {
            this.vehicle_id = event.target.value;
        });

        $('#item_select').select2();
        $('#item_select').on('change', (event) => {
            this.item = event.target.value;
        });
    }
});
